export type AdminRegionContext = {
  id: string;
  name?: string;
  companyId?: string;
  miniProgramId?: string;
  miniProgramName?: string;
};

const ADMIN_REGION_CONTEXT_KEY = 'admin_region_context';

export const getAdminRegionContext = (): AdminRegionContext | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const raw = window.localStorage.getItem(ADMIN_REGION_CONTEXT_KEY);
  if (!raw) {
    return undefined;
  }
  try {
    const parsed = JSON.parse(raw) as AdminRegionContext;
    return parsed?.id ? parsed : undefined;
  } catch (_error) {
    window.localStorage.removeItem(ADMIN_REGION_CONTEXT_KEY);
    return undefined;
  }
};

export const setAdminRegionContext = (context?: AdminRegionContext) => {
  if (typeof window === 'undefined') {
    return;
  }
  if (!context?.id) {
    window.localStorage.removeItem(ADMIN_REGION_CONTEXT_KEY);
    return;
  }
  window.localStorage.setItem(
    ADMIN_REGION_CONTEXT_KEY,
    JSON.stringify(context),
  );
};

export { ADMIN_REGION_CONTEXT_KEY };
